import React, { useEffect } from 'react';
import { trackFbEvent } from '../utils/fbPixel';
const comparisonRows = [{
  situation: 'Tu cursada',
  without: 'Materias sueltas sin conexión entre sí',
  with: 'Todo ordenado por eje curricular y materia'
}, {
  situation: 'Parciales',
  without: 'Estudiás de cero cada vez',
  with: 'Resúmenes, fórmulas y criterios listos'
}, {
  situation: 'Finales',
  without: 'Sin saber por dónde empezar',
  with: 'Banco de preguntas por materia'
}, {
  situation: 'TPs y prácticos',
  without: 'Horas buscando info dispersa',
  with: 'Modelos de informe listos para adaptar'
}, {
  situation: 'Práctica hospitalaria',
  without: 'Llegás sin saber qué hacer frente al paciente',
  with: 'Checklists de procedimientos y PAE listo'
}, {
  situation: 'Cálculos de dosis y goteo',
  without: 'Buscás fórmulas en 10 lugares distintos',
  with: 'Todas las fórmulas en un solo lugar'
}, {
  situation: 'Organización de la cursada',
  without: 'Sin planificación ni seguimiento',
  with: 'Planillas y calendarios editables listos'
}, {
  situation: 'Presentaciones y trabajos',
  without: 'Sin modelo ni formato claro',
  with: 'Plantillas editables listas para usar'
}];
const blocks = [{
  num: '01',
  emoji: '📋',
  title: 'Planificador de Cursada Completo',
  desc: 'Cronograma por cuatrimestre, seguimiento de materias y planificador de parciales, finales y prácticas hospitalarias.'
}, {
  num: '02',
  emoji: '📊',
  title: 'Plantilla PAE Pro Editable',
  desc: 'Valoración completa, diagnósticos NANDA, NIC y NOC en un modelo listo para entregar en trabajos y prácticas.'
}, {
  num: '03',
  emoji: '✍️',
  title: 'Modelos de TPs e Informes',
  desc: 'Plantillas de trabajos prácticos e informes con el formato y lenguaje que piden los docentes.'
}, {
  num: '04',
  emoji: '🗂️',
  title: 'Sistema de Organización de Apuntes',
  desc: 'Organizador por materia, mapa entre materias y checklist de repaso por unidad.'
}];
const assets = ['Planificador semanal', 'Cronograma de cursada', 'Checklist de parciales', 'Seguimiento de materias', 'Plantilla PAE editable', 'Modelos de TPs', 'Organizador de apuntes'];
export function ProBusiness() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(240,249,255) 50%, rgb(255,255,255) 100%)'
  }} data-id="element-230">
      <div className="mx-auto max-w-4xl" data-id="element-231">
        {/* Header */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-232">
          ¿Qué agrega el{' '}
          <span className="text-blue-700" data-id="element-233">
            Kit Premium™?
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 mx-auto max-w-xl m-0 mb-8" data-id="element-234">
          El sistema completo para que no improvises más. Tu cursada, tus TPs y
          tu práctica hospitalaria, organizados desde el primer día.
        </p>

        {/* Scroll hint mobile */}
        <p className="text-xs text-gray-400 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-235">
          <span data-id="element-236">👆</span> Deslizá para ver la tabla completa
        </p>

        {/* Comparison Table */}
        <div className="mb-8 overflow-x-auto rounded-xl shadow-sm touch-pan-x" style={{
        border: '1px solid rgba(59,130,246,0.2)',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-237">
          <div className="min-w-[560px] bg-white rounded-xl overflow-hidden" data-id="element-238">
            {/* Table Header */}
            <div className="grid grid-cols-3 border-b border-gray-100" data-id="element-239">
              <div className="px-4 py-3 text-xs font-bold text-gray-500 uppercase tracking-wide" data-id="element-240">
                Situación
              </div>
              <div className="px-4 py-3 text-xs font-bold text-gray-400 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-241">
                ❌ Sin Kit Premium
              </div>
              <div className="px-4 py-3 text-xs font-bold text-blue-700 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-242">
                ✅ Con Kit Premium
              </div>
            </div>

            {/* Table Rows */}
            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-243">
                <div className="px-4 py-3 text-xs font-bold text-gray-900" data-id="element-244">
                  {row.situation}
                </div>
                <div className="px-4 py-3 text-xs text-gray-500 border-l border-gray-100 bg-gray-50 text-center" data-id="element-245">
                  {row.without}
                </div>
                <div className="px-4 py-3 text-xs text-gray-900 border-l border-gray-100 text-center" style={{
              backgroundColor: 'rgb(240,249,255)'
            }} data-id="element-246">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Blocks */}
        <div className="bg-white border border-blue-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-247">
          <div className="bg-blue-700 px-5 py-3" data-id="element-248">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-249">
              🏆 MEGAPACK ENFERMERÍA: CARRERA RESUELTA + KIT PREMIUM™ INCLUYE:
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-250">
            {blocks.map(block => <div key={block.num} className="flex items-center gap-4 px-5 py-3" data-id="element-251">
                <span className="shrink-0 text-lg font-black text-blue-700/30 w-8 text-center" data-id="element-252">
                  {block.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-253">
                  <span className="block text-sm font-black text-gray-900" data-id="element-254">
                    {block.emoji} {block.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-255">
                    {block.desc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Assets */}
        <div className="rounded-xl px-5 py-4" style={{
        backgroundColor: 'rgb(240,249,255)',
        border: '1px solid rgba(59,130,246,0.2)'
      }} data-id="element-256">
          <p className="text-xs font-bold text-blue-700 uppercase tracking-widest m-0 mb-3" data-id="element-257">
            📊 Editables y plantillas incluidas:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-258">
            {assets.map(asset => <span key={asset} className="text-[11px] font-bold text-blue-700 bg-white border border-blue-700/20 rounded-full px-3 py-1" data-id="element-259">
                {asset}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}